import toNumber from 'lodash/toNumber';
import { type OpenApiSchemaMediaItem } from '../../../api/schema';
import { type MediaField } from './createMediaField';
import { mapFileMetadataToMediaMetadata, mapMediaMetadataToFileMetadata } from './mediaMetadata';

export const mapMediaItemToMediaField = (
    media: OpenApiSchemaMediaItem,
    { id = media.file_id }: { id?: string } = {}
): MediaField => {
    const { file_metadata: fileMetadata, ...restMedia } = media;

    return {
        ...restMedia,
        id,
        sizes: (media.sizes ?? []).map(({ alias, width }) => {
            return {
                alias,
                width: toNumber(width ?? 0),
            };
        }),
        metadata: mapFileMetadataToMediaMetadata(fileMetadata),
    };
};

export const mapMediaFieldToMediaItem = ({
    display_sequence,
    file_id,
    file_path,
    metadata,
    sizes,
    type,
}: MediaField): OpenApiSchemaMediaItem => {
    return {
        display_sequence,
        file_id,
        file_path,
        sizes,
        type,
        file_metadata: mapMediaMetadataToFileMetadata(metadata),
    };
};
